<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>消息</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="allyidu">
				<i class="el-icon-brush"></i>
				<p>一键已读</p>
			</div>
		</div>
		<ul class="messageul">
			<li class="messageli" v-for="(i) in list" @click="yidu(i.m_id)">
				<div class="messageTitle">
					<div>
						<img src="@/assets/tongzhi2.png" v-if="i.type=='system_message'" />
						<img src="@/assets/tongzhi1.png" v-else  /></img>
						<div v-if="i.is_read==0" class="cjamsji"></div>
						<span>{{i.title}}</span>
					</div>
					<p>{{i.create_time}}</p>
				</div>
				<div class="messagebox">
					<p>{{i.content}}</p>
				</div>
			</li>
		</ul>
		<div class="fenye">
		   <el-pagination
			 background
			 @current-change="handleCurrentChange"
			 :current-page.sync="currentPage1"
			 :page-size="10"
			 layout="total, prev, pager, next ,jumper"
			 :total="total">
		   </el-pagination>
		</div>
	</div>
</template>
<script>
	// import rightsidebarImg from '@/common/rightsidebarImg.vue';
	import { mapState } from 'vuex'
	import {
		MessageIndex,
		ReadM_id,
		personal,
		readAll
	} from "@/api/api.js"
	
	export default {
	  name: 'HelloWorld',
	  components:{
		// rightsidebarImg  
	  },
	  data() {
	    return {
			page:1,
			list:[],
			info:"",
			currentPage1:1,
			pagecount:"",
			total:0
	    }
	  },
	  computed: {
	  	...mapState({
	  		user: (state) => state.userInfo || {}
	  	})
	  },
	  created() {
	  	this.msglist()
	  	this.getpersonal()
	  },
	  methods: {
		allyidu(){
			this.$confirm('此操作将所有消息设为已读, 是否继续?', '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
			  this.qingkong()
			}).catch(() => {
				
			});
		},
		
		qingkong(){
			readAll({}).then(res=>{
				this.$message({
					type: 'success',
					message: '设置已读成功'
				});
				this.msglist()
				this.getpersonal()
			})
		},
		getpersonal(){
			return this.$store.dispatch('fetchPersonal').then(() => {
				const u = this.user
				if (u && u.review_status == 1) {
					this.value = true
				} else {
					this.value = false
				}
			})
		},
		handleCurrentChange(e){
		  	this.page=e
		  	this.msglist()
		},
		msglist(){
			MessageIndex({
				page:this.page,
				limit:"10"
			}).then(res=>{
				this.total=res.data.data.total
				this.pagecount=res.data.data.pass_count
				this.currentPage1=res.data.data.current_page
				this.list=res.data.data.data
			})
		},
		yidu(e){
			ReadM_id(e,{}).then(res=>{
				this.msglist()
			})
		}
	  }
	}
</script>
<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 100px;
		height: 30px;
		line-height:30px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
		cursor:pointer;
	}
	.fh_button i{
		margin-right:5px;
	}
	.messageul{
		width:1200px;
		margin:0 auto;
		margin-top:20px;
		margin-bottom:20px;
	}
	.messageli{
		width:100%;
		background-color:#fff;
		padding:12px;
		box-sizing: border-box;
		margin-bottom:16px;
		border-radius:12px;
		cursor:pointer;
	}
	.messageTitle{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		padding-bottom:12px;
	}
	.messageTitle p{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.messageTitle img{
		width:16px;
		height:16px;
		margin-right:5px;
	}
	.messageTitle>div{
		display:flex;
		align-items:center;
		position:relative;
	}
	.cjamsji{
		width:5px;
		height:5px;
		background-color:red;
		position:absolute;
		top: 5px;
		border-radius: 50%;
		left: 10px;
	}
	.messagebox{
		width:100%;
		padding-top:12px;
		border-top:1px solid #EFF0F1;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
	}
	.fenye{
		width:100%;
		padding-bottom:20px;
		display:flex;
		justify-content: center;
	}
	
</style>